import { Controller } from "@hotwired/stimulus"
import { useIntersection, useMutation } from 'stimulus-use';

// Connects to data-controller="link-counter"
export default class LinkCounter extends Controller {
  static values = {
    linkKey: String,
    linkVal: Number
  };

  static watchedLinks = {};

  connect() {
    useIntersection(this, {options:{ threshold: 0.7}});
  }

  appear(entry, observer) {
    LinkCounter.watchedLinks[this.linkKeyValue] = Number(this.linkValValue);
  }

  count_click(entry) {
    console.log(LinkCounter.watchedLinks);
    const watched_value = Object.values(LinkCounter.watchedLinks).reduce((acc, value) => acc + value, 0);
    const watched_count = Object.keys(LinkCounter.watchedLinks).length;

    var json = JSON.stringify({
      locationPath: window.location.pathname,
      locationUrl: window.location.href,
      keysData: window.pageKeys || '',
      links: { watched_value, watched_count, clicked_id: this.linkKeyValue, clicked_value: this.linkValValue} });
    const headers = {type: 'application/json',};
    const blob = new Blob([json], headers);
    navigator.sendBeacon('/stats/', blob);
    LinkCounter.watchedLinks = {};
  }

}
